import { RequestKind, boolean } from '@sb/library/base';
import { CalculateSurchargeInputItem, DisplayItemCollection, MakePaymentInputItem, PaymentCompleteDisplayItem, PaymentSourceDisplayItem, PaymentSourceInputItem, PaymentSourceSearchOptions, PaymentSourceUpdateItem, ProcessPaymentSourceResultItem, SurchargeResultItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace PaymentSourceRoutes {
    export const Get = ApiRoute.Define({
        URL: (paymentSourceID: string) => `paymentsources/${paymentSourceID}`,
        Kind: RequestKind.Get,
        ResultType: PaymentSourceDisplayItem
    });

    export const GetAll = ApiRoute.Define({
        URL: 'paymentsources',
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<PaymentSourceDisplayItem>,
        PagingAllowed: true
    });

    export const Search = ApiRoute.Define({
        URL: 'search/paymentsources',
        Kind: RequestKind.Post,
        BodyType: PaymentSourceSearchOptions,
        ResultType: DisplayItemCollection<PaymentSourceDisplayItem>,
        PagingAllowed: true
    });

    export const CalculateSurcharge = ApiRoute.Define({
        URL: (schoolID?: string) => (schoolID ? `schools/${schoolID}/paymentsources/calculatesurcharge` : 'paymentsources/calculatesurcharge'),
        Kind: RequestKind.Post,
        BodyType: CalculateSurchargeInputItem,
        ResultType: Array<SurchargeResultItem>
    });

    export const ProcessNew = ApiRoute.Define({
        URL: (schoolID?: string) => (schoolID ? `schools/${schoolID}/paymentsources` : 'paymentsources'),
        Kind: RequestKind.Post,
        BodyType: PaymentSourceInputItem,
        ResultType: ProcessPaymentSourceResultItem
    });

    export const Update = ApiRoute.Define({
        URL: (paymentSourceID: string) => `paymentsources/${paymentSourceID}`,
        Kind: RequestKind.Put,
        BodyType: PaymentSourceUpdateItem,
        ResultType: boolean
    });

    export const Delete = ApiRoute.Define({
        URL: (paymentSourceID: string) => `paymentsources/${paymentSourceID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const MakePayment = ApiRoute.Define({
        URL: 'paymentsources/makepayment',
        Kind: RequestKind.Post,
        BodyType: MakePaymentInputItem,
        ResultType: PaymentCompleteDisplayItem
    });
}
